export default __webpack_public_path__ + "static/media/SmartPay.1a9024c1.png";